import { TableField } from "../../../table-field";

const codUgSagres: TableField = {
    key: "codUgSagres",
    label: "Cod. UG",
    tdClass: ["align-middle", "naoQuebrar", "text-left", "text-xl-center"],
    thClass: ["text-center", "naoQuebrar"],
    sortable: false
};
const nmSigla: TableField = {
    key: "nmSigla",
    label: "Nome UG",
    tdClass: ["align-middle", "quebrarPorPalavra", "text-left", "text-xl-center"],
    thClass: ["text-center", "naoQuebrar"],
    sortable: false,
};
const urlTransparencia: TableField = {
    key: "urlTransparencia",
    label: "URL Transp.",
    tdClass: ["align-middle", "quebrarPorPalavra", "text-left", "text-xl-center"],
    thClass: ["text-center", "naoQuebrar"],
    sortable: false,
};
const hashPortal = {
    key: "hashPortal",
    label: "Hash Portal",
    tdClass: ["align-middle", "quebrarPorLetra", "text-left", "text-xl-center"],
    thClass: ["text-center", "naoQuebrar"],
    sortable: false,
};

export const actions: TableField = {
  key: "actions",
  label: "Ações",
  tdClass: ["align-middle", "col-actions", "naoQuebrar", "text-left", "text-xl-center"],
  thClass: ["text-center", "naoQuebrar"],
  sortable: false,
};

export const fieldsUgSerigy: TableField[] = [
    codUgSagres,
    nmSigla,
    urlTransparencia,
    hashPortal,
    actions
];

